import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { DashboardMain } from './common/DashboardMain/DashboardMain'
import { DashboardSidebar } from './common/DashboardSidebar/DashboardSidebar'
import { DashboardTopBar } from './common/DashboardTopBar/DashboardTopBar'

import { useToggle } from 'hooks'
import { SIDEBAR_TOGGLE_STATE_KEY } from './model'

import styles from './DashboardLayout.module.scss'

export const DashboardLayout = ({ children }) => {
  const { handleToggle, isToggled } = useToggle({
    key: SIDEBAR_TOGGLE_STATE_KEY,
    isPersisted: true,
  })

  return (
    <Box className={styles.layout}>
      <DashboardSidebar onToggle={handleToggle} {...{ isToggled }} />
      <Box
        className={cx(styles.content, { [styles.collapsed]: isToggled })}
        direction="column"
      >
        <DashboardTopBar />
        <DashboardMain>{children}</DashboardMain>
      </Box>
    </Box>
  )
}
